module.exports = __webpack_public_path__ + "img/md-light-deeppurple.52a78971.svg";